export const INITIAL_APP_VERSION = '0.0.0.0';
export const INITIAL_SCHEMA_DSL_VERSION = '0.0.0';
export const INITIAL_DEPLOY_VERSION = '0.0.0';
export const SCHEMA_DSL_VERSION = '0.19.9';
